import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { take } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { PrimaryButtonComponent } from '../../../basic/buttons/primary-button/primary-button.component';
import { StripeService } from '../../../core/stripe/stripe.service';
import { BasicPageComponent } from '../../../pages/_shared/basic-page/basic-page.component';
import { MainSidebarComponent } from '../../../pages/_shared/main-sidebar/main-sidebar.component';

@Component({
  selector: 'app-update-subscription-button',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,

    NzIconModule,
    NzInputModule,
    NzButtonModule,
    NzTableModule,
    NzPopoverModule,
    NzUploadModule,
    NzModalModule,
    NzPopconfirmModule,

    MatTooltip,

    BasicPageComponent,
    MainSidebarComponent,
    PrimaryButtonComponent,
  ],
  templateUrl: './update-subscription-button.component.html',
  styleUrl: './update-subscription-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpdateSubscriptionButtonComponent {
  constructor(
    private stripeService: StripeService,
    private messageService: NzMessageService
  ) {}

  onUpdateSubscriptionClick() {
    this.stripeService
      .getCustomerPotalUrl$()
      .pipe(take(1))
      .subscribe((data) => {
        if (data) {
          window.open(data, '_blank');
        } else {
          this.messageService.error(`Cannot update the subscription. Please contact us: ${environment.supportEmail}`);
        }
      });
  }
}
